<span class="" *ngIf="peoples.length==0">Loading data please wait..</span>
<ng-container *ngIf="peoples.length>0">
    <h2 mat-dialog-title >
       <span  class="groupIcon"><mat-icon>group_add</mat-icon></span>
        Shared {{modulenameContact}}/Role/User
          <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
        </h2>
  <mat-dialog-content class="mat-typography">
    
    <ul class="selectedlist">
     
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="pic">
            <img *ngIf="user.imageUrl!='' " src="{{user.imageUrl}}" alt="">
              <span *ngIf="user.imageUrl=='' " class="username">
                  {{user.shortName}}
                </span>
          </div>
          <div class="detail">
              <h4>{{user.name}}</h4>
              <p>{{user.email}}</p>
              <p *ngIf="user.shareToType==1">({{modulenameContact}})</p>
              <p *ngIf="user.shareToType==2">(Role)</p>
              <p *ngIf="user.shareToType==4">(User)</p>    
          </div>
      </div>
      <div class="option">
        <ng-container *ngFor="let action of getActionType(user.permission)">
        
          <button mat-flat-button  *ngIf="user.permission==0"  [matMenuTriggerFor]="menu"  aria-label="Permission">
           <mat-icon>visibility</mat-icon> {{action}}
          </button>
          
          <button mat-flat-button  *ngIf="user.permission==1"  [matMenuTriggerFor]="menu"  aria-label="Permission">
            <mat-icon>text_fields</mat-icon> {{action}}
          </button>
          
          <button mat-flat-button  *ngIf="user.permission==-1"  [matMenuTriggerFor]="menu"  aria-label="Permission">
            <mat-icon>delete</mat-icon> {{action}}
          </button>

        </ng-container>

        <mat-menu #menu="matMenu" xPosition="before">

          <button (click)="actionSelected('Viewer',0,user.shareToID)"  mat-menu-item>
            <mat-icon>visibility</mat-icon><span>Viewer</span>
          </button>

          <button (click)="actionSelected('Editor',1,user.shareToID)" mat-menu-item>
            <mat-icon>text_fields</mat-icon>
            <span>Editor</span>
          </button>

          <button (click)="actionSelected('Remove',-1,user.shareToID)" mat-menu-item>
            <mat-icon>delete</mat-icon>
            <span>Remove</span>
          </button>
         
        </mat-menu>
      </div>
      </li>
    </ul>
    
   
  </mat-dialog-content>
  
  <mat-dialog-actions >
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]=!showAddButton (click)="FormFolderContactRoleUpdate()">Done
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>
</ng-container>



